module.exports = __webpack_public_path__ + "assets/8ab743ae5446066214f7c9990c14fd63.mp3";